export const FASTSHIFT_LOCALSTORAGE_KEYS = {
	SELECTED_ORG_ID: 'fastshift-selected-org',
};

export const TABLE_IDS = {
	SELECTION: 'selection',
	MIGRATION_TICKETS: 'migrationTickets',
} as const;
